import React from 'react'
import { Tag } from 'antd'

function PlayerFilter(props) {
	const playerList = [...new Set(props.playerList)]
	const aliasesList = [...new Set(props.aliasesList)]

	const removePlayer = (tagToBeRemoved) => {
		if (props.isHero === null) {
			props.onModify(tagToBeRemoved, 'remove', 'all', false)
		} else {
			props.onModify(tagToBeRemoved, 'remove', props.isHero ? 'hero' : 'villain', false)
		}
	}
	const removeAlias = (aliasToBeRemoved) => {
		if (props.isHero === null) {
			props.onModify(aliasToBeRemoved, 'remove', 'all', true)
		} else {
			props.onModify(aliasToBeRemoved, 'remove', props.isHero ? 'hero' : 'villain', true)
		}
	}

	return (
		<p style={{ marginTop: '7px', maxHeight: '80px' }}>
			{playerList.map((item) => (
				<Tag key={item} style={{ marginTop: 4 }} closable={!props.disabled} onClose={() => removePlayer(item)}>
					{item}
				</Tag>
			))}
			{aliasesList.length > 0 && ( // divider item
				<div style={{ width: '100%', height: 1, backgroundColor: '#303030', marginTop: 8, marginBottom: 4 }} />
			)}
			{aliasesList.map((item) => (
				<Tag
					style={{ marginTop: 4 }}
					key={item.aliasId}
					closable={!props.disabled}
					onClose={() => removeAlias(item)}
				>
					<span
						style={{
							display: 'inline-flex',
							borderRadius: '50%',
							width: 7,
							height: 7,
							marginRight: 5,
							backgroundColor: item.color,
						}}
					/>
					{item.aliasName}
				</Tag>
			))}
		</p>
	)
}

export default PlayerFilter
